import {
  LOGIN_AFTER_SSO_PROCESS_STARTED,
  LOGIN_AFTER_SSO_PROCESS_SUCCESS,
  LOGIN_AFTER_SSO_PROCESS_FAILED
} from "../../constants";

import { LOGIN_VIA_SSO } from "../../../../config/constants";
import { ApiBase } from "../../../utils/apiBase";
import { withType } from "../../../utils/actionOperations";

export const SSOLoginAction = (params, cb) => {
  const apiBaseInstance = new ApiBase();
  return (dispatch) => {
    dispatch(withType(LOGIN_AFTER_SSO_PROCESS_STARTED));
    return apiBaseInstance.instance
      .post(LOGIN_VIA_SSO, params)
      .then((res) => {
        dispatch(withType(LOGIN_AFTER_SSO_PROCESS_SUCCESS, res.data));
        cb && cb(true, res.data)
      })
      .catch((err) => {
        dispatch(withType(LOGIN_AFTER_SSO_PROCESS_FAILED, err));
        cb && cb(false, err)
      });
  };
};

